/** Cards in the discard area that end the game. */
export const DISCARD_LIMIT = 10;
export const MIN_PLAYERS = 2;
export const MAX_PLAYERS = 6;
/** Disconnect grace before the "vote to end early" button appears. */
export const DISCONNECT_GRACE_MS = 60_000;
/** No action from anyone for this long -> room marked abandoned. */
export const ROOM_IDLE_MS = 2 * 60 * 60 * 1000;
/** Abandoned rooms are deleted this long afterwards. */
export const ROOM_DELETE_AFTER_MS = 60 * 60 * 1000;
